import './welcome-back-overlay.scss'

export function setupWelcomeBackOverlay(player, elem) {
  const container = elem.closest('.video-js')
  container.append(`
    <div class="video-js--welcome-back-overlay">
      <div class="video-js--welcome-back-overlay__text">
        <p>${elem.data('welcome-back-title')}</p>
        <p>${elem.data('welcome-back-subtitle')}</p>
      </div>
      <div class="video-js--welcome-back-overlay__actions">
        <button id="video-js--welcome-back-overlay__actions-play" class="t-btn t-btn-primary t-btn-lg t-btn-icon-left">
          <i class="fa-regular fa-circle-play s-icon"></i>
          <span class="t-btn-main-label">
            ${elem.data('welcome-back-play')}
          </span>
        </button>
        <button id="video-js--welcome-back-overlay__actions-restart" class="t-btn t-btn-secondary-gray t-btn-lg t-btn-icon-left">
          <i class="fa-regular fa-arrow-rotate-left s-icon"></i>
          <span class="t-btn-main-label">
            ${elem.data('welcome-back-start-over')}
          </span>
        </button>
      </div>
    </div>
  `)

  const resumeVideoCallback = (options = {}) => {
    return (e) => {
      if (options.restart) player.currentTime(0)

      setTimeout(() => player.play(), 0)
      container.find('.video-js--welcome-back-overlay').remove()
    }
  }

  container
    .find('#video-js--welcome-back-overlay__actions-play')
    .on('click', resumeVideoCallback())

  container
    .find('#video-js--welcome-back-overlay__actions-restart')
    .on('click', resumeVideoCallback({ restart: true }))
}
